const buildQueryString = (query = {}) => {
  const sp = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    sp.set(key, String(value));
  });
  const qs = sp.toString();
  return qs ? `?${qs}` : "";
};

const parseJsonSafely = async (res) => {
  try {
    return await res.json();
  } catch {
    return {};
  }
};

const joinPathnames = (basePathname = "", nextPathname = "") => {
  const base = String(basePathname || "/");
  const baseNormalized =
    base === "/" ? "" : base.replace(/\/+$/, "");

  const next = String(nextPathname || "");
  const nextNormalized = next.replace(/^\/+/, "");

  const joined = `${baseNormalized}/${nextNormalized}`;
  return joined.replace(/\/{2,}/g, "/");
};

export const apiRequest = async (
  baseUrl,
  { path, method = "GET", query, body, headers }
) => {
  if (!baseUrl) throw new Error("Missing API base URL");
  if (!path) throw new Error("Missing API path");

  const url = new URL(baseUrl);
  url.pathname = joinPathnames(url.pathname, path);
  url.search = buildQueryString(query);

  const res = await fetch(url.toString(), {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(headers || {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  const data = await parseJsonSafely(res);

  if (!res.ok) {
    const message =
      data?.error ||
      data?.message ||
      `Request failed with status ${res.status}`;
    throw new Error(message);
  }

  if (data && data.ok === false) {
    const message = data?.error || data?.message || "Request failed";
    throw new Error(message);
  }

  return data;
};
